import React, { useRef } from 'react';

import { MenuItem } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { default as Tooltip } from '@material-ui/core/Tooltip/Tooltip';
import { default as ExportIcon } from '@material-ui/icons/GetApp';

import TranslationHelper from '../../../helpers/TranslationHelper';
import { IExportOptions } from '../../SourceSetGrid/types';
import PopperWrapper from '../../PopperWrapper';

interface IOwnProps {
    types: IExportOptions[];
    buttonClass: string;
}

const ButtonsMenu = ({ types, buttonClass }: IOwnProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const popperRef = useRef<HTMLDivElement>(null);

    const hideMenu = () => {
        setAnchorEl(null);
    };

    const handleClick = (button: IExportOptions) => {
        button.handler();
        hideMenu();
    };

    return (
        <>
            <Tooltip title={TranslationHelper.translate('Export')}>
                <Button
                    className={buttonClass}
                    aria-controls="export-menu"
                    aria-haspopup="true"
                    onClick={openMenu}
                >
                    <ExportIcon />
                </Button>
            </Tooltip>
            <PopperWrapper
                id="export-menu"
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                popperRef={popperRef}
            >
                {types.map((button) => {
                    return (
                        <MenuItem
                            key={button.name}
                            onClick={() => handleClick(button)}
                        >
                            {TranslationHelper.translate(button.name)}
                        </MenuItem>
                    );
                })}
            </PopperWrapper>
        </>
    );
};

export default ButtonsMenu;
